// extracted by mini-css-extract-plugin
module.exports = {"buyingGuides":"BuyingGuidesAccordion_buyingGuides__moVub","buyingGuide":"BuyingGuidesAccordion_buyingGuide__oYemT"};